import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getOfferType, isCommercial, isFlat, isNewbuilding } from '../../../utils/offer_type';
import { getDealType, isRent, isSale } from '../../../utils/deal_type';

export interface ILegalBanner {
  text: string;
  type: string;
  title: string;
  landing_mark: string;
}

export const RENT_BLOCK: ILegalBanner = {
  landing_mark: 'arenda',
  text: 'Снимайте жилье у адекватных собственников',
  title: 'Проверьте арендодателя',
  type: 'check-landlord',
};

export const NEW_BUILDING_BLOCK: ILegalBanner = {
  landing_mark: 'zastroishik',
  text: 'Проверьте застройщика на надежность',
  title: 'Юридическая чистота жилья',
  type: 'check-developer',
};

export const FLAT_BLOCK: ILegalBanner = {
  landing_mark: 'vtorichka',
  text: 'Проверьте жилье на скрытых собственников и обременения',
  title: 'Юридическая чистота жилья',
  type: 'check-owners',
};

export const SECONDARY_BLOCK: ILegalBanner = {
  landing_mark: 'vtorichka',
  title: 'Юридическая чистота объекта',
  text: 'Проверьте чистоту объекта',
  type: 'check-owners',
};

export function getBanner(offer: IOfferSchema): ILegalBanner | null {
  const offerType = getOfferType(offer);
  const dealType = getDealType(offer);

  if (isCommercial(offerType)) {
    return null;
  }

  if (isRent(dealType)) {
    return RENT_BLOCK;
  }

  if (isNewbuilding(offerType)) {
    return NEW_BUILDING_BLOCK;
  }

  if (isFlat(offerType)) {
    return FLAT_BLOCK;
  }

  if (isSale(dealType)) {
    return SECONDARY_BLOCK;
  }

  return null;
}
